import TERMS from "./terms";

export default TERMS;
